import React from 'react';
import { motion } from 'framer-motion';
export function WhatIsICD() {
  return <section className="bg-arena py-16 md:py-[80px]" data-id="element-45">
      <div className="max-w-[1200px] mx-auto px-6 md:px-20" data-id="element-46">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-16 md:gap-24 items-center" data-id="element-47">
          {/* Left Column */}
          <motion.div initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.4,
          ease: 'easeOut'
        }} data-id="element-48">
            <span className="block font-body text-[11px] uppercase font-medium text-salvia tracking-widest mb-4" data-id="element-49">
              EL ÍNDICE
            </span>
            <h2 className="font-display text-[32px] md:text-[40px] font-bold text-carbon leading-[1.1] mb-6" data-id="element-50">
              ¿Qué es el Índice de Confianza Digital™?
            </h2>
            <div className="space-y-4" data-id="element-51">
              <p className="font-body text-[16px] text-carbon/65 leading-[1.7]" data-id="element-52">
                El ICD™ es una métrica de 0 a 100 que mide la capacidad de la
                presencia digital de una empresa para generar confianza,
                comunicar valor y convertir visitantes en oportunidades
                comerciales.
              </p>
              <p className="font-body text-[16px] text-carbon/65 leading-[1.7]" data-id="element-53">
                A diferencia de métricas técnicas como el tráfico o el
                posicionamiento en buscadores, el ICD™ mide algo más
                fundamental: la percepción que un cliente potencial tiene de la
                empresa en los primeros segundos de contacto digital.
              </p>
            </div>
          </motion.div>

          {/* Right Column - Visualization */}
          <motion.div className="flex flex-col items-center justify-center bg-arena-dark rounded-xl p-10 border border-salvia/20" initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.4,
          ease: 'easeOut',
          delay: 0.2
        }} data-id="element-54">
            <div className="relative w-48 h-48 flex items-center justify-center mb-8" data-id="element-55">
              <svg className="absolute inset-0 w-full h-full transform -rotate-90" data-id="element-56">
                <circle cx="96" cy="96" r="88" stroke="rgba(23,23,23,0.05)" strokeWidth="8" fill="none" data-id="element-57" />
                <circle cx="96" cy="96" r="88" stroke="#4F7CFF" strokeWidth="8" fill="none" strokeDasharray="552.9" strokeDashoffset="326.2" className="transition-all duration-1000" data-id="element-58" />
              </svg>
              <div className="text-center" data-id="element-59">
                <span className="font-display text-[48px] font-bold text-azul leading-none" data-id="element-60">
                  41
                </span>
                <span className="font-display text-[20px] font-bold text-azul/50" data-id="element-61">
                  /100
                </span>
              </div>
            </div>

            <div className="w-full max-w-[280px] space-y-2 mb-6" data-id="element-62">
              <div className="flex justify-between font-body text-[13px]" data-id="element-63">
                <span className="text-[#E85555]" data-id="element-64">0-30:</span>
                <span className="text-[#E85555]" data-id="element-65">Brecha crítica</span>
              </div>
              <div className="flex justify-between font-body text-[13px]" data-id="element-66">
                <span className="text-[#E8A855]" data-id="element-67">31-50:</span>
                <span className="text-[#E8A855]" data-id="element-68">Brecha significativa</span>
              </div>
              <div className="flex justify-between font-body text-[13px]" data-id="element-69">
                <span className="text-[#E8C855]" data-id="element-70">51-70:</span>
                <span className="text-[#E8C855]" data-id="element-71">Brecha moderada</span>
              </div>
              <div className="flex justify-between font-body text-[13px]" data-id="element-72">
                <span className="text-salvia" data-id="element-73">71-85:</span>
                <span className="text-salvia" data-id="element-74">Presencia sólida</span>
              </div>
              <div className="flex justify-between font-body text-[13px]" data-id="element-75">
                <span className="text-verde" data-id="element-76">86-100:</span>
                <span className="text-verde" data-id="element-77">Presencia de alto impacto</span>
              </div>
            </div>

            <p className="font-body text-[13px] text-carbon/40 italic text-center" data-id="element-78">
              El promedio en empresas B2B colombianas en primer análisis es
              41/100.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}